import { makeStyles } from '@material-ui/core';

/** @type {import("@mui/material").SxProps<typeof import('@mui/material/styles').Theme>} */
const styles = makeStyles(theme => ({
    troubleMainContainer: {
        maxWidth: '995px',
        margin: 'auto',
    },
    TroubleContainer: props => ({
        boxShadow: theme?.palette?.boxShadow,
        borderRadius: '0.375rem',
        marginTop: '3rem',
        [theme.breakpoints.down('sm')]: {
            background: `url(${props?.troubleTileMobile}) no-repeat center/cover`,
            backgroundColor: theme.palette.backgroundColor,
        },
        [theme.breakpoints.up('sm')]: {
            background: `url(${props?.troubleTileTablet}) right/cover no-repeat`,
            backgroundColor: theme.palette.backgroundColor,
        },
        [theme.breakpoints.up('md')]: {
            background: `url(${props?.troubleTileDesktop}) 100% 100%/cover no-repeat `,
            backgroundColor: theme.palette.backgroundColor,
        },
    }),
    TroubleCentre: {
        display: 'flex',
        justifyContent: 'center',
        [theme.breakpoints.down('sm')]: {
            alignItems: 'center',
        },
    },
    TroubleDetails: {
        display: 'flex',
        [theme.breakpoints.down('sm')]: {
            alignItems: 'center',
        },
    },
    TroubleBox: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        [theme.breakpoints.down('sm')]: {
            textAlign: 'center',
            padding: '0',
        },
        [theme.breakpoints.between('sm', 'md')]: {
            padding: '2rem 0 2rem 2rem',
        },
    },
    TroubleTitle: {
        color: theme?.palette?.textHeading,
        letterSpacing: 'inherit',
    },
    TroubleDescription: {
        paddingTop: '1rem',
        color: theme?.palette?.textBody,
        letterSpacing: 'inherit',
        [theme.breakpoints.down('xs')]: {
            padding: '1rem 0rem 0 0rem',
        },
    },
    troubleIcon: {
        width: '5.375rem',
        height: '4.625rem',
    },
    TroubleCTA: {
        padding: '1.5rem 0 1.625rem 0',
        [theme.breakpoints.down('xs')]: {
            padding: '2rem 0 0 0',
            width: '100%',
        },
        [theme.breakpoints.between('sm', 'md')]: {
            paddingTop: '1.5rem',
            paddingBottom: 0,
        },
    },
    TroubleText: {
        padding: '3.875rem 0 0 3.5rem',
        textAlign: 'left',
        [theme.breakpoints.down('xs')]: {
            textAlign: 'center',
            padding: '2rem 1rem 1.938rem 1rem',
        },
        [theme.breakpoints.between('sm', 'md')]: {
            textAlign: 'left',
            padding: '0',
        },
    },
    TroubleTextAlign: {
        textAlign: 'center',
        paddingTop: '1rem',
        [theme.breakpoints.down('sm')]: {
            paddingTop: '1.5rem',
        },
    },
    TroubleCenterAlign: {
        marginTop: '3rem',
        borderRadius: '0.375rem',
        boxShadow: theme?.palette?.boxShadow,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: theme?.palette?.backgroundColor,
    },
    TroubleBoxCenter: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        padding: '1.625rem 0 0 0',
        textAlign: 'center',
        [theme.breakpoints.down('xs')]: {
            textAlign: 'center',
            padding: '2rem 1rem 1.938rem 1rem',
        },
        [theme.breakpoints.between('sm', 'md')]: {
            textAlign: 'left',
            padding: '2rem 0 2rem 0rem',
        },
    },
    ForegroundImageContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: 0,
        [theme.breakpoints.down('xs')]: {
            justifyContent: 'center',
            alignItems: 'flex-start',
            paddingBottom: '3.44rem',
        },
        [theme.breakpoints.between('sm', 'md')]: {
            justifyContent: 'center',
            alignItems: 'center',
        },
    },
    ForegroundImage: props => ({
        width: '12.106rem',
        height: '10.106rem',
        [theme.breakpoints.up('md')]: {
            background: `url(${props?.troubleTileForegroundDesktop}) 100% 100%/cover no-repeat`,
        },
        [theme.breakpoints.down('sm')]: {
            background: `url(${props?.troubleTileForegroundMobile}) no-repeat center/cover `,
            width: '7rem',
            height: '6rem',
        },
        [theme.breakpoints.between('sm', 'md')]: {
            background: `url(${props?.troubleTileForegroundTablet}) right/cover no-repeat`,
        },
    }),
}));

export default styles;
